import { useEffect, useState } from 'react';

import { useGetPOSCompanies, useGetPOSSellersByCompany } from '@backoffice/services/companies';

const SELLER_SEARCH_DEBOUNCE_MS = 300;

const resolveSellerFilters = (search: string) => {
  const term = search.trim();
  if (!term) return {};
  if (/^\d+$/.test(term)) return { barteSellerId: Number(term) };
  return { sellerName: term };
};

export const useStepLinkConfigData = (selectedPayfacId?: number, sellerSearch = '') => {
  const [debouncedSellerSearch, setDebouncedSellerSearch] = useState(sellerSearch);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSellerSearch(sellerSearch), SELLER_SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [sellerSearch]);

  const { data: payfacsData, isLoading: isPayfacsLoading } = useGetPOSCompanies({
    page: 0,
    size: 400,
  });

  const { data: sellersData, isLoading: isSellersLoading } = useGetPOSSellersByCompany({
    companyId: selectedPayfacId,
    size: 50,
    ...resolveSellerFilters(debouncedSellerSearch),
  });

  return {
    payfacs: payfacsData?.data?.content ?? [],
    isPayfacsLoading,
    sellers: sellersData?.data?.content ?? [],
    isSellersLoading,
  };
};
